export default {
  layout: 'alert-layout',
  text: 'alert-text',
  subText: 'alert-subText',
};
